import { MiniGame } from '@core/models/mini-games.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class MiniGameEntityService extends EntityCollectionServiceBase<MiniGame> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('MiniGame', serviceElementsFactory);
  }
}